import PortalIdParser from 'PortalIdParser';
export const PORTAL_ID = PortalIdParser.get();